import { Sine, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as VoiceOver from "../Data/VoiceOver";
import { InteruptType, VoiceCategory } from "../GameObjects/VoiceOverManager";

import { SplashLoadingText } from "../GameObjects/SplashLoadingText";

export class SplashScreen extends HLF.SplashScreen {
    private _bg!: PIXI.Sprite;
    private _loadingText!: SplashLoadingText;

    public constructor() {
        super();
    }

    public init(pSize: PIXI.Point): void {
        super.init(pSize);

        this._bg = HLF.PixiUtils.makeSprite("splash");
        this._bg.interactive = true;
        this.addChild(this._bg);

        this._loadingText = new SplashLoadingText();
        this._loadingText.position.set(0, 180);
        this.addChild(this._loadingText);

        this.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void): void {
        this._loadingText.animateIn(pOnComplete);
        if (Constants.DEBUG_MINIMAL_AUDIO === false) {
            const state: AudioContextState = (window as any).Howler?.ctx?.state || (window as any).Howler?.state;
            if (state === "running") {
                Application.instance.voiceOver.play(VoiceOver.U1, InteruptType.LESS, VoiceCategory.UI);
            }
            else if (state === undefined) {
                console.error("Failed to get AudioContext state from Howler");
            }
            else {
                console.log("Skipping title VO because AudioContext state is " + state);
            }
        }
    }

    public animateOut(pOnComplete: () => void): void {
        TweenMax.to(this, 0.5, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: pOnComplete,
        });
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }
}
